import React from 'react';
import {
  HamburgerIcon,
  RemoveCuvetteLidIcon,
  RemoveSolutionIcon,
} from '../../../Icons';
import {hasItem} from '../Cuvette.utils';

export function useCuvetteTooltip(props) {
  function removeOnClick(params) {
    return function () {
      props.onRemoveItem(params);
    };
  }

  function getButtonList() {
    let buttonList = [
      {
        onClick: () => {props.buttonList[0].onClick()},
        image: HamburgerIcon,
      },
    ];
    if (hasItem(props.lidId)) {
      buttonList.push({
        onClick: removeOnClick({lidId: props.lidId}),
        altText: 'Remove lid',
        image: RemoveCuvetteLidIcon,
      });
    }
    if (props.solution) {
      buttonList.push({
        onClick: removeOnClick({solution: props.solution}),
        altText: 'Remove solution',
        image: RemoveSolutionIcon,
      });
    }
    return buttonList;
  }

  return {getButtonList};
}
